var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSelectArrowBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 5"
}, props), ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#363636",
  d: "M9 0 4.5 5 0 0h9z"
})));
export default SvgSelectArrowBlack;